module.exports = __webpack_public_path__ + "img/8P.1aadacdf.png";